var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 105,
    viewBox: "0 0 108 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 0H88.875C99.45 0 108 8.52564 108 19.0705V85.9295C108 96.4744 99.45 105 88.875 105H19.125C8.55 105 0 96.4744 0 85.9295V19.0705C0 8.52564 8.55 0 19.125 0Z",
    fill: "#1D1B1B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5312_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7116 88.4211C48.3038 88.4211 53.6539 83.1084 53.6539 76.5625V64.704H41.7116C35.1194 64.704 29.7693 70.0166 29.7693 76.5625C29.7693 83.1084 35.1194 88.4211 41.7116 88.4211Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7693 52.8454C29.7693 46.2995 35.1194 40.9868 41.7116 40.9868H53.6539V64.704H41.7116C35.1194 64.704 29.7693 59.3913 29.7693 52.8454Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7693 29.1283C29.7693 22.5824 35.1194 17.2697 41.7116 17.2697H53.6539V40.9869H41.7116C35.1194 40.9869 29.7693 35.6742 29.7693 29.1283Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6538 17.2697H65.5961C72.1883 17.2697 77.5384 22.5824 77.5384 29.1283C77.5384 35.6742 72.1883 40.9869 65.5961 40.9869H53.6538V17.2697Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5384 52.8454C77.5384 59.3913 72.1883 64.704 65.5961 64.704C59.004 64.704 53.6538 59.3913 53.6538 52.8454C53.6538 46.2995 59.004 40.9868 65.5961 40.9868C72.1883 40.9868 77.5384 46.2995 77.5384 52.8454Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5312_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.7692,
    height: 71.1513,
    fill: "white",
    transform: "translate(29.7693 17.2697)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.9bc7276f7905cf3ab45171f099d0ce9d.svg";
export { ForwardRef as ReactComponent };